import { useState, useEffect } from "react";
import { useDebounce } from "../../modules/usinas/debouncer";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function RopTableSearch(props: {
  search: string;
  setSearch: (search: string) => void;
  width?: string | number;
  height?: string | number;
  placeholder?: string;
}) {
  const [searchTerm, setSearchTerm] = useState<string>(props.search);
  const debouncedSearchTerm: string = useDebounce<string>(searchTerm, 500);
  useEffect(() => {
    if (debouncedSearchTerm || debouncedSearchTerm === "") {
      props.setSearch(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);
  return (
    <TextField
      placeholder={props.placeholder ? props.placeholder : "Buscar por nome"}
      value={searchTerm}
      size="small"
      sx={{
        width: "200px",
        color: "#222D35",
        "& .MuiOutlinedInput-root": {
          borderRadius: "4px",
          height: "42px",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
        },
      }}
      InputProps={{
        style: {
          fontSize: 16,
        },
        startAdornment: (
          <InputAdornment position="start" sx={{ color: "#8B9095" }}>
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        style: { fontSize: 16 },
      }}
      onChange={(e) => {
        setSearchTerm(e.target.value);
      }}
    />
    // <Paper
    //   component="form"
    //   sx={{
    //     width: width ?? "200px",
    //     color: "#222D35",
    //     "& .MuiOutlinedInput-root": {
    //       borderRadius: "4px",
    //       height: "42px",
    //       backgroundColor: "rgba(255, 255, 255, 0.05)",
    //     },
    //   }}
    // >
    //   <FontAwesomeIcon
    //     style={{
    //       marginLeft: "20px",
    //       marginRight: "10px",
    //     }}
    //     color="#222D35"
    //     size="sm"
    //     icon={faSearch}
    //   />
    //   <InputBase
    //     sx={{
    //       ml: 1,
    //       flex: 1,
    //       fontSize: "16px",
    //       fontFamily: "Poppins",
    //       fontWeight: 400,
    //       input: {
    //         "&::placeholder": {
    //           color: "#656C72",
    //         },
    //       },
    //     }}
    //     placeholder="Buscar por nome"
    //     value={searchTerm}
    //     onChange={(e) => {
    //       setSearchTerm(e.target.value);
    //     }}
    //   />
    // </Paper>
  );
}
